module.exports = __webpack_public_path__ + "assets/img/a397-ge.svg";